<template>
  <div class="box">
    <div class="columns">
      <div class="column is-7">
        <div class="is-flex is-align-items-center is-justify-content-space-between">
          <!-- green phone -->
          <img class="operation_icon" @click="applicantAnswered" width="25px" src="/applicant_answered.svg" />
          <!-- whatsapp -->
          <img @click="openWhatsappModal" src="/whatsapp.svg" class="btn height_30px" :class="{ 'is-blocked-control': applicantData.blocked }" width="30px">
          <!-- whatsapp -->
          <button class="button is-success is-small" @click="openWhatsappConversation">Send WA</button>
          <div>
            <!-- updated at -->
            <div>
              {{ $moment(applicantData.updated_at).format('DD/MM/YYYY') }}
            </div>
          </div>
          <!-- ganah flag -->
          <div>
            <GhanaFlag :payload="applicantData" :additional_data="{ resource_type: 'Applicant' }" :eager_load="true" />
          </div>
        </div>
        <div class="is-flex mt-3">
          <LastWorkingPlaces :history_companies="historyCompanies" :applicant="applicantData" />
        </div>
        <div class="mt-4">
          <Message :payload="applicantData" :additional_data="{ endpoint: '/users/', headers: 'admin_headers', resource_type: 'Applicant', isShowKeyWord: true }" />
        </div>
      </div>
      <div class="column">
        <div class="columns mb-0">
          <div class="column is-flex is-flex-direction-column is-align-items-center">
            <!-- files -->
            <div>
              <img @click="openFilesModal" src="/files_icon.png" class="btn height_30px" width="30px">
            </div>
            <!-- is star -->
            <div class="mt-3">
              <IsStar :payload="{ resource_id: applicantData.resource_id, resource: { applicant: applicantData } }" />
            </div>
            <!-- create new alert(suitcase) -->
            <div class="my-3">
              <CompanySuitcase :payload="applicantData" imageStyle="image-style" />
            </div>
            <!-- go to applicant -->
            <div class="mx-3">
              <router-link :to="{ name: 'admin-applicants', query: { show_id: applicantData.resource_id } }" class="blue_text"><u><b>APPLICANT</b></u></router-link>
            </div>
          </div>
          <div class="column">
            <!-- vetting advanced -->
            <button @click="openNewVettingModal" class="button is-info is-small is-fullwidth">Vetting</button>
            <!-- followup -->
            <button @click="openFollowUp" class="button is-info is-small is-fullwidth mt-2">Follow up</button>
            <!-- old applicant modal (current) -->
            <button @click="openOldApplicantModal" class="button is-primary is-small is-fullwidth mt-2">Old modal</button>
            <!-- skills -->
            <button @click="openSkillsModal" class="button is-outlined is-small is-info is-fullwidth mt-2">Skills</button>
            <!-- find matching positions -->
            <button @click="openPositionRecommendation" class="button is-small is-fullwidth mt-2" style="background: #7c5cbf; color: white;">המלץ משרות</button>
            <!-- chatbot conversation view -->
            <button @click="openChatbotPanel" class="button is-small is-fullwidth mt-2 chatbot-btn" title="צפה בשיחת צ'אטבוט">
              <span>Chatbot</span>
              <span class="new-badge">NEW</span>
            </button>
          </div>
        </div>
        <div class="has-text-left">
          <div>Min Salary: {{ minSalaryExpectations }}</div>
          <LocationEditor :payload="{ location, resource_type: 'Applicant', resource_id: applicantData.resource_id }" />
          <AttributeDisplay
            :value="applicantData.certification_date"
            :displayValue="seniorityYears.toString()"
            :data="applicantData"
            componentName="CrudCertificationDateSeniority"
            title="Certification Date"
            requestName="updateApplicant"
            requestValue="certification_date"
            type="radio-group"
            classValue="is-4"
            classTitle="is-8 has-text-left ltr"
            classContainer="is-flex-direction-row-reverse"
            :beforeAction="certificationDateUpdate"
            :horizantal="false"
          />
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

import TextsHelper from '@/custom/classes/texts_helper.js'
import GhanaFlag from '@/components/GhanaFlag.vue'
import LocationEditor from '@/components/LocationEditor.vue'
import CompanySuitcase from '@/components/CompanySuitcase'
import IsStar from '@/components/IsStar.vue'
import Message from '@/components/Message.vue'
import LastWorkingPlaces from '@/components/LastWorkingPlaces.vue'
import AttributeDisplay from '@/components/AttributeDisplay'
import { BLOCKED_TOAST } from '@/custom/helpers/applicant_block.js'

export default {
  name: 'ApplicantControlModule',
  components: {
    GhanaFlag,
    CompanySuitcase,
    LocationEditor,
    IsStar,
    Message,
    LastWorkingPlaces,
    AttributeDisplay
  },
  props: {
    applicantData: {
      type: Object,
      required: true
    }
  },
  data () {
    return {
      texts_helper: new TextsHelper(),
      applicantName: this.applicantData.first_name + ' ' + this.applicantData.last_name,
      rawText: '',
      location: {},
      texts: {},
      minSalaryExpectations: '',
      historyCompanies: []
    }
  },
  computed: {
    seniorityYears () {
      return this.$moment().diff(this.applicantData.certification_date, 'years')
    }
  },
  created () {
    this.init()
  },
  methods: {
    async init () {
      const data = this.applicantData
      this.minSalaryExpectations = data.min_salary_expectations || ''
      this.getLocation()
      this.getTexts()
      this.getHistoryCompanies()
    },
    certificationDateUpdate (value) {
      const date = this.$moment(value.split('/').reduce((prev, curr) => curr + '-' + prev, '1')).format('YYYY-MM-DD')
      this.applicantData.certification_date = date
    },
    async getTexts () {
      const response = await this.$network_utils.getResourceTexts({ current_type: 'Applicant', current_resource_id: this.applicantData.resource_id })
      this.setTexts(response)
    },
    setTexts (server_response) {
      let temp_texts = {}
      for (let i = 0; i < server_response.length; i++) {
        let text = server_response[i]
        let designator = text.designator
        text.content = this.texts_helper.getContent(text)
        temp_texts[designator] = text
      }
      this.texts = temp_texts
    },
    async getLocation () {
      [this.location] = await this.$network_utils.getResourceLocations({ current_type: 'Applicant', current_resource_id: this.applicantData.resource_id })
    },
    async getHistoryCompanies () {
      this.historyCompanies = await this.$network_utils.getApplicantHistoryCompanies({ current_type: 'Applicant', current_applicant_id: this.applicantData.resource_id })
    },
    openWhatsappModal () {
      // Blocked candidate: no manual wa.me links either (v2 contract).
      if (this.applicantData.blocked) {
        this.$utils.emit('show_toast', { text: BLOCKED_TOAST })
        return
      }
      this.create({
        designator: 'applicant-whatsapp-modal',
        component_name: 'ModalWhatsapp',
        modal_title: this.applicantData.first_name + ' ' + this.applicantData.last_name + ' - מועמד',
        modal_width: 500,
        is_center_modal: true,
        props: {
          applicant: this.applicantData
        }
      })
    },
    openFollowUp () {
      this.create({
        designator: 'resource-alerts-form-modal',
        component_name: 'ApplicantAlertsForm',
        modal_width: 2000,
        is_center_modal: true,
        data: this.applicantData,
        resource_type: 'Applicant',
        modal_title: `Alerts - ${this.$utils.getResourceFullName({ resource_type: 'Applicant', data: this.applicantData })} ${this.applicantData.phone_number}`
      })
    },
    async applicantAnswered () {
      await this.$network_utils.postStat({
        title: 'Applicant answered phone',
        designator: 'applicant_answered_phone',
        status: 'active',
        owner: this.$utils.getOwner().name,
        priority: 5,
        resource_type: 'Applicant',
        resource_id: this.applicantData.resource_id
      })
      this.$utils.emit('show_toast', { text: 'success' })
    },

    openFilesModal () {
      this.create({ designator: 'applicant-files-modal', component_name: 'Files', applicant_data: this.applicantData, applicant_id: this.applicantData.resource_id, modal_title: this.applicantName + ' Files' })
    },
    openSkillsModal () {
      this.create({ designator: 'applicant-skill-form-modal', component_name: 'ApplicantSkillsForm', data: this.applicantData, modal_title: this.applicantName + ' Skills', modal_width: 1300, is_center_modal: true })
    },
    openNewVettingModal () {
      let modal_title = this.applicantData.first_name + ' ' + this.applicantData.last_name + ' Vetting'
      this.create({ designator: 'vetting-modal', component_name: 'ModalVettingForm', applicant_id: this.applicantData.resource_id, modal_title: modal_title, ignore_escape_button: true, modal_width: 2400, is_center_modal: true })
    },
    openWhatsappConversation () {
      this.create({
        designator: 'applicant-whatsapp-modal',
        component_name: 'ModalWhatsappMessager',
        modal_title: this.applicantData.first_name + ' ' + this.applicantData.last_name + ' - מועמד',
        modal_width: 700,
        is_center_modal: true,
        props: {
          applicant: this.applicantData
        }
      })
    },
    openPositionRecommendation () {
      this.create({
        designator: 'position-recommendation-modal',
        component_name: 'PositionRecommendationModal',
        data: { applicant_id: this.applicantData.resource_id, applicant_name: this.applicantName },
        modal_title: 'המלץ על משרות - ' + this.applicantName,
        modal_width: 700,
        is_center_modal: true
      })
    },
    openChatbotPanel () {
      if (!this.applicantData || !this.applicantData.resource_id) return
      const applicantId = this.applicantData.resource_id
      // The operation slug tells the readonly panel which tenant API to query.
      const slug = this.$settings.get({ path: 'intake_operation_slug' })
      let chatbotUrl = `https://chatbot.test.panel.hasama.online?applicant_id=${applicantId}&readonly=true&view=applicant`
      if (slug) chatbotUrl += `&operation=${slug}`
      window.open(chatbotUrl, '_blank')
    },
    openOldApplicantModal () {
      const modalTitle = this.applicantName + this.$utils.getVetted(this.applicantData)
      this.create({
        designator: 'applicant-old-modal',
        component_name: 'ApplicantInfo',
        data: this.applicantData,
        modal_title: modalTitle,
        override_modal_x: 370,
        modal_width: 1500,
        modal_open_action: 'click'
      })
    },
    ...mapMutations('modals', ['create'])
  }
}
</script>

<style scoped>
.is-blocked-control {
  opacity: 0.4;
  filter: grayscale(100%);
  cursor: not-allowed;
}
.chatbot-btn {
  background: linear-gradient(135deg, #00b09b, #96c93d);
  color: white;
  border: none;
  position: relative;
  font-weight: 600;
}

.chatbot-btn:hover {
  background: linear-gradient(135deg, #009688, #7cb342);
  color: white;
}

.new-badge {
  position: absolute;
  top: -8px;
  right: -6px;
  background: #ff3860;
  color: white;
  font-size: 9px;
  font-weight: 700;
  padding: 1px 5px;
  border-radius: 8px;
  line-height: 1.4;
  animation: badge-pulse 1.5s ease-in-out infinite;
}

@keyframes badge-pulse {
  0%, 100% { opacity: 1; transform: scale(1); }
  50% { opacity: 0.6; transform: scale(1.15); }
}
</style>
